import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const textEffectsNeonSign: DataBindingComponentModel = {
  panel: {
    height: 212,
    title: 'Connect_Panel_Title_TextEffects',
    // TODO: add help id
    helpId: '',
  },
  componentName: 'TextEffects_db_comp_name',
  sections: [
    {
      role: 'TextEffectsRole',
      bindings: [
        {
          title: 'Connect_Panel_Connect_TextEffects_Label',
          prop: 'text',
          supportedFieldTypes: [
            FieldType.text,
            FieldType.email,
            FieldType.number,
            FieldType.dateTime,
            FieldType.time,
            FieldType.url,
            FieldType.address,
            FieldType.richText,
          ],
          defaultFieldType: FieldType.text,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_TextEffects_Link_Label',
          prop: 'link',
          event: 'onClick',
          supportedFieldTypes: [
            FieldType.document,
            FieldType.url,
            FieldType.image,
            FieldType.video,
          ],
          defaultFieldType: FieldType.url,
          supportPageLinks: true,
          supportsActions: true,
          supportsReferenceFields: true,
          supportsPostSubmit: true,
          supportsUrlTarget: true,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'gfpp_edit_text',
              label: 'TextEffects_db_edit_text_label',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'TextEffects_db_manage_content',
      },
    },
  ],
  compactErrorPanel: true,
}
